// Only necessary to override the default options for the browser update script
// in aubrey/aubrey/static/aubrey/assets/src/js/common/_browser-update.js:

const browserUpdateOpts = {

};

export default browserUpdateOpts;
